import React from 'react';

import active_lang from 'src/langs/jp_en';

export default function OrdersPageLoading() {
  return <>{active_lang.LOADING_ORDERS}</>;
}
